import { decompressJson } from './utils.js';
import CourierBoldCompressed from './Courier-Bold.compressed.json' with { type: 'json' };
import CourierBoldObliqueCompressed from './Courier-BoldOblique.compressed.json' with { type: 'json' };
import CourierObliqueCompressed from './Courier-Oblique.compressed.json' with { type: 'json' };
import CourierCompressed from './Courier.compressed.json' with { type: 'json' };
import HelveticaBoldCompressed from './Helvetica-Bold.compressed.json' with { type: 'json' };
import HelveticaBoldObliqueCompressed from './Helvetica-BoldOblique.compressed.json' with { type: 'json' };
import HelveticaObliqueCompressed from './Helvetica-Oblique.compressed.json' with { type: 'json' };
import HelveticaCompressed from './Helvetica.compressed.json' with { type: 'json' };
import TimesBoldCompressed from './Times-Bold.compressed.json' with { type: 'json' };
import TimesBoldItalicCompressed from './Times-BoldItalic.compressed.json' with { type: 'json' };
import TimesItalicCompressed from './Times-Italic.compressed.json' with { type: 'json' };
import TimesRomanCompressed from './Times-Roman.compressed.json' with { type: 'json' };
import SymbolCompressed from './Symbol.compressed.json' with { type: 'json' };
import ZapfDingbatsCompressed from './ZapfDingbats.compressed.json' with { type: 'json' };
// prettier-ignore
const compressedJsonForFontName = {
    'Courier': CourierCompressed,
    'Courier-Bold': CourierBoldCompressed,
    'Courier-Oblique': CourierObliqueCompressed,
    'Courier-BoldOblique': CourierBoldObliqueCompressed,
    'Helvetica': HelveticaCompressed,
    'Helvetica-Bold': HelveticaBoldCompressed,
    'Helvetica-Oblique': HelveticaObliqueCompressed,
    'Helvetica-BoldOblique': HelveticaBoldObliqueCompressed,
    'Times-Roman': TimesRomanCompressed,
    'Times-Bold': TimesBoldCompressed,
    'Times-Italic': TimesItalicCompressed,
    'Times-BoldItalic': TimesBoldItalicCompressed,
    'Symbol': SymbolCompressed,
    'ZapfDingbats': ZapfDingbatsCompressed,
};
export var FontNames;
(function (FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})(FontNames || (FontNames = {}));
const fontCache = {};
export class Font {
    constructor() {
        this.getWidthOfGlyph = (glyphName) => this.CharWidths[glyphName];
        this.getXAxisKerningForPair = (leftGlyphName, rightGlyphName) => (this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
    }
}
Font.load = (fontName) => {
    const cachedFont = fontCache[fontName];
    if (cachedFont)
        return cachedFont;
    const json = decompressJson(compressedJsonForFontName[fontName]);
    const font = Object.assign(new Font(), JSON.parse(json));
    font.CharWidths = font.CharMetrics.reduce((acc, metric) => {
        acc[metric.N] = metric.WX;
        return acc;
    }, {});
    font.KernPairXAmounts = font.KernPairs.reduce((acc, [name1, name2, width]) => {
        if (!acc[name1])
            acc[name1] = {};
        acc[name1][name2] = width;
        return acc;
    }, {});
    fontCache[fontName] = font;
    return font;
};
//# sourceMappingURL=Font.js.map